import { Button } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import type { TresorerieType } from '@/types';
import ModalPosteComptable from './ModalPosteComptable';
import PosteComptableForm from './PosteComptableForm';

type PosteComptableFormHandlerProps = {
  tresorerie?: Omit<TresorerieType, 'identifiant'> & { identifiant?: number };
  error?: boolean;
  onChange?: (tresorerie: Partial<TresorerieType>) => void;
};

const PosteComptableFormHandler = (props: PosteComptableFormHandlerProps) => {
  const { tresorerie, error, onChange } = props;

  const [tresorerieModalOpen, setTresorerieModalOpen] = React.useState<null | 'edit' | 'add'>(null);

  const handleSave = React.useCallback(
    (posteComptable) => {
      if (onChange) {
        onChange(posteComptable);
      }

      setTresorerieModalOpen(null);
    },
    [onChange],
  );

  const handleModalTresorerieToggle = React.useCallback(
    (mode) => {
      if (!_.isNil(tresorerieModalOpen)) {
        setTresorerieModalOpen(null);
      } else {
        setTresorerieModalOpen(mode);
      }
    },
    [tresorerieModalOpen],
  );

  if (_.isEmpty(tresorerie)) {
    return (
      <>
        <Button
          data-testid="add-button-poste-comptable"
          content="Ajouter un poste comptable"
          basic
          color={error ? 'red' : undefined}
          icon="add"
          onClick={() => handleModalTresorerieToggle('add')}
        />
        {tresorerieModalOpen === 'add' && (
          <ModalPosteComptable
            onClose={() => handleModalTresorerieToggle(null)}
            onSave={handleSave}
          />
        )}
      </>
    );
  }

  return (
    <>
      <PosteComptableForm
        tresorerie={tresorerie}
        onChange={onChange}
        onEditClick={() => handleModalTresorerieToggle('edit')}
      />
      {tresorerieModalOpen === 'edit' && (
        <ModalPosteComptable
          tresorerie={tresorerie}
          onClose={() => handleModalTresorerieToggle(null)}
          onSave={handleSave}
        />
      )}
    </>
  );
};

export default PosteComptableFormHandler;
